import { Component, OnInit, inject } from "@angular/core";
import {
	UntypedFormControl,
	UntypedFormGroup,
	Validators
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { DealerInfoDTO } from "@shared/model/dealer.model";
import { DealerService } from "@shared/services/dealers/dealer.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

@Component({
	selector: "app-user-signup",
	templateUrl: "./user-signup.component.html",
	styleUrl: "./user-signup.component.scss",
	standalone: false
})
export class UserSignupComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	private dealerService = inject(DealerService);
	private router = inject(Router);
	private userService = inject(UserApiService);
	wcmService = inject(WcmService);

	bsConfig: Partial<BsDatepickerConfig> = {
		containerClass: "theme-red",
		adaptivePosition: true,
		dateInputFormat: "DD/MM/YYYY"
	};
	userForm: UntypedFormGroup = new UntypedFormGroup({
		surname: new UntypedFormControl("", Validators.required),
		name: new UntypedFormControl("", Validators.required),
		fiscalCode: new UntypedFormControl(""),
		email: new UntypedFormControl("", [
			Validators.required,
			Validators.email
		]),
		birthDate: new UntypedFormControl(""),
		idDealer: new UntypedFormControl("", Validators.required),
		dealerName: new UntypedFormControl("", Validators.required),
		consent1: new UntypedFormControl("", Validators.required),
		consent2: new UntypedFormControl("", Validators.required),
		consent3: new UntypedFormControl("", Validators.required)
	});

	email;
	tag;
	dealerId: any;
	dealerInfo: DealerInfoDTO;
	showCFError = false;
	country;

	ngOnInit() {
		this.activatedRoute.queryParams.subscribe(params => {
			this.email = params["email"];
			this.userForm.controls["email"].setValue(this.email);
			this.dealerId = params["dealerId"];
			this.dealerService
				.getDealerInfoUsingGET(this.dealerId)
				.subscribe(value => {
					this.dealerInfo = value;
					this.userForm.controls["idDealer"].setValue(
						this.dealerInfo.idDealer
					);
					this.userForm.controls["dealerName"].setValue(
						this.dealerInfo.businessName
					);
					this.setUserValidators();
					this.country = this.dealerInfo.idMarket;
				});
		});
		/* const reader = new FileReader(),
			reader2 = new FileReader(),
			reader3 = new FileReader(); */
	}

	setUserValidators() {
		const birthDate = this.userForm.get("birthDate"),
			fiscalCode = this.userForm.get("fiscalCode");

		switch (this.dealerInfo.idMarket) {
			case "IT":
				birthDate.setValidators([Validators.required]);
				fiscalCode.setValidators([
					Validators.maxLength(16),
					Validators.required,
					Validators.pattern(
						"^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$"
					)
				]);
				break;
			case "ES":
				birthDate.setValidators(null);
				fiscalCode.setValidators([
					Validators.minLength(9),
					Validators.maxLength(9)
				]);
				break;
			case "DE":
				birthDate.setValidators(null);
				fiscalCode.setValidators([
					Validators.minLength(11),
					Validators.maxLength(11)
				]);
				break;
			case "BE":
			case "FR":
			case "EN":
			case "NL":
				birthDate.setValidators(null);
				fiscalCode.setValidators(null);
				break;
			default:
				birthDate.setValidators(null);
				fiscalCode.setValidators([Validators.maxLength(20)]);
				break;
		}
		birthDate.updateValueAndValidity();
		fiscalCode.updateValueAndValidity();
	}

	onSubmit() {
		if (!this.userForm.invalid) {
			const birthDate: Date = new Date(this.userForm.controls["birthDate"].value),
				dateWithoffset =
					birthDate.getTime() - birthDate.getTimezoneOffset() * 6e4;

			switch (this.dealerInfo.idMarket) {
				case "IT":
					this.userService
						.isValidCFUsingGET(
							dateWithoffset,
							this.userForm.controls["fiscalCode"].value,
							this.userForm.controls["name"].value,
							this.userForm.controls["surname"].value
						)
						.subscribe(value => {
							if (!value) {
								this.showCFError = true;
								document
									.getElementById("workForm")
									.scrollIntoView(true);
							} else {
								this.showCFError = false;
								this.userService
									.registerUserUsingPOST(
										this.userForm.getRawValue()
									)
									.subscribe(value => {
										this.router.navigate(["/"]);
									});
							}
						});
					break;
				default:
					this.userService
						.registerUserUsingPOST(this.userForm.getRawValue())
						.subscribe(value => {
							this.router.navigate(["/"]);
						});
			}
		}
	}
}
